import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ServerAction } from '@cbridge-packages/server';
import { ClientAction } from '@cbridge-packages/client';
import { selectedNodeIdSelector } from '@cbridge-modules/symbol-pool-filter';

type IState =
  & IGetSelectorStateType<typeof selectedNodeIdSelector>;

export const reloadServerListEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    ServerAction.create.done,
    ServerAction.remove.done,
    ServerAction.createServerStream.done,
    ServerAction.removeServerStream.done,
    ClientAction.update.done,
    ClientAction.remove.done,
  ),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const nodeId = selectedNodeIdSelector(state);

    return [
      ServerAction.loadList.started({ nodeId }),
    ];
  }),
);
